<template>
	<div
		class="inline-flex items-center rounded-full bg-background-primary border border-border-tertiary shadow-sm p-1 transitiona-all duration-300"
		role="navigation"
	>
		<button type="button" class="btn btn-primary p-2" :disabled="isLoading" @click="$emit('toggle-miniatures')">
			<NuxtIcon :name="visible ? 'x' : 'custom/book-open'" class="text-2xl" filled />
		</button>
		<span class="text-body-primary">
			<slot />
		</span>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		visible: boolean;
		isLoading: boolean;
	}

	interface Emits {
		(e: 'toggle-miniatures'): void
	}

	defineProps<Props>();
	defineEmits<Emits>();
</script>
